import axios from "axios";

export default function checkMaintenanceStatus() {
  return new Promise((resolve, reject) => {
    axios
      .get(`/account/public/api/v1/check-maintenance`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data));
  });
}
